module.exports = __webpack_public_path__ + "media/img/Landing_Page/logos/35-d19b97d27fe216e8a741ebd499df9e5c.jpg";